<template>
    <div class="l-ss-c-catalog-content">
        <div
            class="l-ss-c-catalog-breadcrumbs"
            v-if="lastCategoryFromPath">
            <div
                class="l-ss-c-catalog-breadcrumbs-item"
                @click="showCategoryByBreadcrumbs(null)">
                <span>Каталог</span>
                <i v-html="iconArrowRight"></i>
            </div>

            <div
                class="l-ss-c-catalog-breadcrumbs-item"
                v-for="(breadcrumb, i) in pathToCurrentCategory"
                :key="i"
                @click="showCategoryByBreadcrumbs(breadcrumb)">
                <span>{{ breadcrumb.title }}</span>
                <i
                    v-html="iconArrowRight"
                    v-if="breadcrumb.id !== lastCategoryFromPath.id"></i>
            </div>
        </div>

        <div class="l-ss-c-catalog-content-mobile-title">
            <i
                v-html="iconArrowLeft"
                v-if="lastCategoryFromPath"
                @click="goBack"></i>
            <span>{{ !lastCategoryFromPath ? 'Каталог' : lastCategoryFromPath.title }}</span>
        </div>

        <div
            class="l-ss-c-catalog-content-mobile-show-more"
            v-if="lastCategoryFromPath"
            @click="$emit('change', { event: $event, category: lastCategoryFromPath })">
            Посмотреть все товары
        </div>

        <transition-group
            :name="animationName"
            tag="div"
            class="l-ss-c-catalog-mobile-categories">
            <category-item
                v-for="category in currentCategories"
                :key="category.id"
                :category="category"
                @click="changeCategory"/>
        </transition-group>
    </div>
</template>

<script>
    import { ref, computed } from '@vue/composition-api';

    import iconArrowLeft from '@/core/assets/images/icons/arrow-left.svg';
    import iconArrowRight from '@/core/assets/images/icons/arrow-right.svg';

    import CategoryItem from '@/core/components/catalog/category-item.vue';

    export default {
        components: { CategoryItem },
        model: {
            prop: 'selectedCategory',
            event: 'input',
        },
        props: {
            categories: {
                type: Array,
                required: true,
            },
            selectedCategory: {
                type: Object,
            },
        },
        setup(props, { emit }) {
            const pathToCurrentCategory = computed(() => {
                const { selectedCategory } = props;

                if (!selectedCategory) {
                    return [];
                }

                if (!selectedCategory.parent) {
                    return [selectedCategory];
                }

                return [selectedCategory.parent, selectedCategory];
            });

            const animationName = ref('slide-right');

            const lastCategoryFromPath = computed(() => {
                const pathLength = pathToCurrentCategory.value.length;

                return pathLength ? pathToCurrentCategory.value[pathLength - 1] : null;
            });

            const currentCategories = computed(() => {
                return lastCategoryFromPath.value ? lastCategoryFromPath.value.child : props.categories;
            });

            const changeCategory = (data) => {
                const { category } = data;

                if (!category.child || !category.child?.length) {
                    emit('change', data);
                    return;
                }

                animationName.value = 'slide-right';
                emit('input', category);
            };

            const showCategoryByBreadcrumbs = (category) => {
                animationName.value = 'slide-left';
                emit('input', category);
            };

            const goBack = () => {
                animationName.value = 'slide-left';
                emit('input', props.selectedCategory.parent);
            };
            
            return {
                iconArrowLeft,
                iconArrowRight,
                currentCategories,
                pathToCurrentCategory,
                lastCategoryFromPath,
                animationName,
                changeCategory,
                goBack,
                showCategoryByBreadcrumbs,
            };
        },
    };
</script>

<style scoped>

</style>